enum LeagueEntryStatusEnum {
  None = 0,
  Open = 1,
  Settled = 2,
}

export default LeagueEntryStatusEnum;
